import { useCallback } from 'react';
import { CanvasElementType } from '../canvas-types';
import { useReactFlow } from '@xyflow/react';
import last from 'lodash/last';
import { ShortNodeInfo } from '../normalizeGroupPositions';
import { isSectionSupportedDropElement } from '../canvas-element-tool/helper';

/**
 * Hook that provides a function to find the section node that intersects with a given node.
 * Returns the last intersecting section node found, if any.
 */
export const useGetIntersectionSection = () => {
  const { getIntersectingNodes } = useReactFlow();

  const getIntersectionSection = useCallback(
    (node: ShortNodeInfo) => {
      if (!isSectionSupportedDropElement(node.type)) {
        return null;
      }
      const intersections = getIntersectingNodes(node, false).filter(
        (n) => n.type === CanvasElementType.SECTION,
      );
      const sectionNode = last(intersections);
      return sectionNode ?? null;
    },
    [getIntersectingNodes],
  );

  return {
    getIntersectionSection,
  };
};
